import classNames from 'clsx';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HOME_BROWSE_PATH } from 'src/common/constants/paths';
import { TUNE_IN_BADGE_LOGO } from 'src/common/constants/localizations/shared';
import { BackArrow } from '../BackArrow';
import css from '../browsies-header.module.scss';
import assetUrl from '../../../../utils/assetUrl';

const tiBadgeSrc = assetUrl('assets/img/ti-badge-white.svg');

export function Badge({ showBackArrow, goBack, getLocalizedText }) {
  return showBackArrow ? (
    <div className={css.primaryBadge}>
      <BackArrow goBack={goBack} getLocalizedText={getLocalizedText} />
    </div>
  ) : (
    <div className={classNames(css.primaryBadge, css.tiBadgeContainer)}>
      <Link to={HOME_BROWSE_PATH}>
        <img
          src={tiBadgeSrc}
          width="30"
          height="20"
          role="presentation"
          alt={getLocalizedText(TUNE_IN_BADGE_LOGO)}
        />
      </Link>
    </div>
  );
}

Badge.propTypes = {
  showBackArrow: PropTypes.bool,
  goBack: PropTypes.func.isRequired,
  getLocalizedText: PropTypes.func.isRequired,
};
